import { useAppSelector } from '../../hooks';

export const useFeedSelector = () => {
    return useAppSelector(state => state.feed);
};
